import { Container, Image, TextArea, Form, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import { useSelector, useDispatch } from "react-redux"
import { setLetterCapCallData, setLetterContactPoint } from "../../redux/projectSlice"

const CapCallDetailRejection = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const handleSelectChange = (e, data) => {
        dispatch(setLetterContactPoint(data.value));
    }

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const legalRepresentative = lp.contacts.find(contact => contact.type === 'LegalRepresentative') ?? {}
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {legalRepresentative.title} {legalRepresentative.firstName} {legalRepresentative.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </Container>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const commission = projectState.capCallCommission
        const legalRepresentative = projectState.leadPartner.contacts.find(contact => contact.type === 'LegalRepresentative') ?? {}
        const title = project.title.find(title => title.language === 'EN')?.translation
        const selectedContactPoint = projectState.contactPoints.filter(contactPoint => contactPoint.value === letter?.contactPoint) ?? {}
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)

        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {legalRepresentative.title} {legalRepresentative.lastName},</p>
                <p>We are grateful for your efforts and the interest you have shown in our cooperation Programme by submitting a capitalisation initiative.</p>
                <p>However, we regret to inform you that the Interreg NWE Monitoring Committee decided not to select your capitalisation initiative <span className="text-accent">{project.customIdentifier} – {title} ({project.acronym})</span> for funding during its meeting on {commission.date}, in {commission.location}.</p>
                <p>The Monitoring Committee conclusions are annexed to this letter and aim to provide better insight on this decision.</p>
                <p>We kindly ask you to inform your partners.</p>
                {/* <p>If you have questions and would like more information regarding this decision, please contact your responsible JS officer <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print" onChange={handleSelectChange} /> {letter?.jsOfficer ? <span className="invisible-screen">{letter.jsOfficer[0]} <span className="text-accent">({letter.jsOfficer[1]})</span></span> : <span className="error-accent">Please select an Officer</span>}.</p> */}
                <p>If you have questions and would like more information regarding this decision, please contact <Select placeholder="Select contact point" defaultValue={selectedContactPoint} options={projectState.contactPoints} className="invisible-print" onChange={handleSelectChange} /> {!letter?.contactPoint?.length ? undefined : <span className="invisible-screen">{letter?.contactPoint[0]} <span className="text-accent">({letter?.contactPoint[1]})</span></span>}.</p>
                <p>Should you have a complaint regarding this decision, you can find more information regarding the available options in Chapter 7 of the Programme Manual.</p>
                <p>Kind regards,</p>
                <p className="espace-haut">David Grzegorzewski</p>
                <p>Programme Director</p>
            </Container>
        )
    }

    const renderLetterDetails = () => {
        const letter = projectState.letter
        return (
            <Container textAlign='justified' >
                <h3>Monitoring Committee conclusions</h3>
                <div className="little-margin">
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print" onChange={(e, data) => dispatch(setLetterCapCallData({ key: 'conclusions', value: data.value }))} value={letter?.capCallData?.conclusions ?? ''}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.capCallData?.conclusions}</p>
                </div>
                <p>After careful consideration, the Monitoring Committee has concluded that the project application does not sufficiently meet the criteria to be selected for funding despite its merits.</p>
            </Container>
        )
    }

    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                            <div className="page-break">
                                {renderLetterDetails()}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default CapCallDetailRejection;
